import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { DarkModeProvider } from './context/DarkModeContext';
import { ExperimentProvider } from './context/ExperimentContext';
import { Header } from './components/Shared/Header';
import { ProtectedRoute } from './components/Shared/ProtectedRoute';
import { BannedScreen } from './components/Shared/BannedScreen';
import { Login } from './components/Auth/Login';
import { Signup } from './components/Auth/Signup';
import { RequestFeed } from './components/Requests/RequestFeed';
import { PostRequest } from './components/Requests/PostRequest';
import { MyRequests } from './components/Dashboard/MyRequests';
import { UserProfile } from './components/Profiles/UserProfile';
import { Leaderboard } from './components/Leaderboard/Leaderboard';
import { TeacherDashboard } from './components/Teacher/TeacherDashboard';
import { ReportUser } from './components/Profiles/ReportUser';
import './App.css';

function AppContent() {
  const { user, profile, loading, isBanned } = useAuth();
  
  if (loading) return <div className="loading-screen"><p>Loading...</p></div>;
  if (user && isBanned) return <BannedScreen />;

  return (
    <>
      <Header />
      <main className="app-main">
        <Routes>
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
          <Route path="/signup" element={!user ? <Signup /> : <Navigate to="/" />} />
          <Route path="/" element={<ProtectedRoute user={user} profile={profile}><RequestFeed /></ProtectedRoute>} />
          <Route path="/post-request" element={<ProtectedRoute user={user} profile={profile}><PostRequest /></ProtectedRoute>} />
          <Route path="/my-requests" element={<ProtectedRoute user={user} profile={profile}><MyRequests /></ProtectedRoute>} />
          <Route path="/profile/:userId?" element={<ProtectedRoute user={user} profile={profile}><UserProfile /></ProtectedRoute>} />
          <Route path="/report/:userId?/:requestId?" element={<ProtectedRoute user={user} profile={profile}><ReportUser /></ProtectedRoute>} />
          <Route path="/leaderboard" element={<ProtectedRoute user={user} profile={profile}><Leaderboard /></ProtectedRoute>} />
          <Route path="/teacher-dashboard" element={<ProtectedRoute user={user} profile={profile} requireTeacher={true}><TeacherDashboard /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <DarkModeProvider>
        <AuthProvider>
          <ExperimentProvider>
            <AppContent />
          </ExperimentProvider>
        </AuthProvider>
      </DarkModeProvider>
    </Router>
  );
}
